import api from './api';

export const getSwapQuote = (quoteParams) => api.post('/swap/quote', quoteParams);

export const buildSwapCalldata = (buildParams) => api.post('/swap/build-calldata', buildParams);
